import { useSelector } from 'react-redux';
import MatchConfidenceLevel from '../../Data/MatchConfidenceLevel';

/**
 * Hook to access match confidence state for the Match Confidence Meter component.
 *
 * Returns:
 * - isShown: boolean indicating if the meter should be displayed (based on feature flag)
 * - confidenceLevel: string - current match confidence level ('-', 'fair', 'medium', 'high')
 * - lastShownLevel: string - last non-NULL confidence level shown to user
 *
 * @returns {Object} Match confidence state and visibility flag
 */
const useMatchConfidence = () => {
  const { showSmartMatchMeter } = useSelector((store) => store.features || {});
  const { matchConfidence } = useSelector(
    (store) => store.supplierMatches || {}
  );

  const isShown = !!showSmartMatchMeter;
  const confidenceLevel =
    matchConfidence?.confidenceLevel ?? MatchConfidenceLevel.NULL;
  const lastShownLevel =
    matchConfidence?.lastShownLevel ?? MatchConfidenceLevel.NULL;

  return {
    isShown,
    confidenceLevel,
    lastShownLevel,
  };
};

export default useMatchConfidence;
